import { CONVENTIONAL, FOV_PREVIEW_HEIGHT, FOV_PREVIEW_WIDTH } from 'helpers/globals'
import { backgroundSize as backgroundSizeFn } from 'helpers/fovPreview/backgroundSize'
import backgroundPositionFn from 'helpers/fovPreview/backgroundPosition'
import constrainedImageSize from 'helpers/fovPreview/constrainedImageSize'
import clipFn from 'helpers/fovPreview/clip'
import scenes from 'helpers/fovPreview/scenes'
import equals from 'ramda/src/equals'

export default function setComponentValues({ prevState, cameraChanged, ...props }) {
  const { fovMode, horizontalAngleOfView, verticalAngleOfView, horizontalResolution, verticalResolution, backgroundPosition, scene } = props
  const conventional = fovMode === CONVENTIONAL
  const aspectRatio = conventional ? 3 / 4 : 4 / 3
  const angleOfView = conventional ? horizontalAngleOfView : verticalAngleOfView
  const resolutionAspectRatio = horizontalResolution / verticalResolution

  const width = conventional ? (prevState.containerWidth || FOV_PREVIEW_WIDTH) : (prevState.containerHeight || FOV_PREVIEW_HEIGHT)
  const height = conventional ? (prevState.containerHeight || FOV_PREVIEW_HEIGHT) : (prevState.containerWidth || FOV_PREVIEW_WIDTH)

  const previousBackgroundSize = prevState.backgroundSize
  const nextBackgroundSize = backgroundSizeFn({ angleOfView, width, height, aspectRatio, conventional })

  let clip = clipFn({ aspectRatio: resolutionAspectRatio, width, height })
  // remove clip if fisheye and 360 / 270 AoV
  // https://github.com/ipvideomarketinfo/calculator-v3/issues/749
  if ((horizontalAngleOfView > 180) && equals(scene, scenes['360'])) {
    clip = 0
  }
  const calculatedBackgroundPosition = cameraChanged ? backgroundPosition : backgroundPositionFn({ previousBackgroundPosition: prevState.backgroundPosition || backgroundPosition, width, height, conventional, nextBackgroundSize, previousBackgroundSize })

  return {
    backgroundPosition: constrainedImageSize({ width, height, conventional, clip, backgroundSize: nextBackgroundSize, backgroundPosition: calculatedBackgroundPosition, horizontalAngleOfView }),
    backgroundSize: nextBackgroundSize,
    conventional, width, height, aspectRatio, angleOfView, resolutionAspectRatio, clip
  }
}



// WEBPACK FOOTER //
// ./src/helpers/fovPreview/setComponentValues.js